import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);

    // 👇 COD Handling Fee injection on checkout
    document.addEventListener('click', async (event) => {
      // Shopify checkout button is always rendered as <button name="checkout">
      if (event.target.matches('button[name="checkout"]')) {
        // Optional: add small delay if drawer uses AJAX cart updates
        await this.addCODFee();
      }
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    // Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }

  // ✅ Adds COD Handling Fee product to cart
  async addCODFee() {
    try {
      const feeHandle = 'cash-on-delivery-cod-handling-fee'; // replace with your actual handle
      const response = await fetch(`/products/${feeHandle}.js`);
      const product = await response.json();

      // Check if COD fee already exists in cart to prevent duplicates
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      const alreadyAdded = cart.items.some(item => item.handle === feeHandle);
      if (alreadyAdded) {
        console.log('COD Handling Fee already in cart.');
        return;
      }

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: product.variants[0].id, quantity: 1 })
      });

      console.log('✅ COD Handling Fee added to cart.');
    } catch (error) {
      console.error('❌ Error adding COD fee:', error);
    }
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
